<template>
  <div class="ds-form">
    <el-form ref="elForm" :model="formData" :rules="rules" :label-position="labelPosition" :label-width="labelWidth"
      v-bind="formAttrs" @keyup.enter="emit('keyup:enter')">
      <el-row v-bind="rowAttrs" style="width: 100%; flex-wrap: wrap">
        <template v-for="item in formItems">
          <el-col :key="item.prop" v-if="!item?.isHidden" v-bind="item?.colAttrs || colAttrs">
            <template v-if="isInputType(item.type)">
              <slot v-if="item?.slotName" :name="item.slotName" :formItem="item"></slot>
              <el-form-item v-else :prop="item.prop" :label="item.label"
                :label-position="item?.labelPosition || labelPosition" :label-width="item?.labelWidth || labelWidth"
                :rules="item.rules" v-bind="item.formItemAttrs">
                <el-input v-model.trim="formData[item.prop]" :placeholder="item.placeholder" :type="item.type"
                  :show-password="item.type === 'password'" autosize clearable v-bind="item.otherOptions" />
              </el-form-item>
            </template>
            <template v-else-if="item.type === 'inputNumber'">
              <slot v-if="item?.slotName" :name="item.slotName" :formItem="item"></slot>
              <el-form-item v-else :prop="item.prop" :label="item.label"
                :label-position="item?.labelPosition || labelPosition" :label-width="item?.labelWidth || labelWidth"
                :rules="item.rules" v-bind="item.formItemAttrs">
                <el-input-number v-model.trim="formData[item.prop]" style="width: 100%" :placeholder="item.placeholder"
                  :min="0" controls-position="right" v-bind="item.otherOptions" />
              </el-form-item>
            </template>
            <template v-else-if="isDateRangeType(item.type)">
              <slot v-if="item?.slotName" :name="item.slotName" :formItem="item"></slot>
              <el-form-item v-else :prop="item.prop" :label="item.label"
                :label-position="item?.labelPosition || labelPosition" :label-width="item?.labelWidth || labelWidth"
                :rules="item.rules" v-bind="item.formItemAttrs">
                <el-date-picker v-model="formData[item.prop]" style="width: 100%" :type="item.type"
                  value-format="yyyy/MM/dd" placeholder="选择日期" start-placeholder="开始日期" end-placeholder="结束日期" clearable
                  v-bind="item.otherOptions" />
              </el-form-item>
            </template>
            <template v-else-if="item.type === 'select'">
              <slot v-if="item?.slotName" :name="item.slotName" :formItem="item"></slot>
              <el-form-item v-else :prop="item.prop" :label="item.label"
                :label-position="item?.labelPosition || labelPosition" :label-width="item?.labelWidth || labelWidth"
                :rules="item.rules" v-bind="item.formItemAttrs">
                <el-select v-model="formData[item.prop]" style="width: 100%" :placeholder="item.placeholder" clearable
                  filterable v-bind="item.otherOptions" @change="(value) => handleSelectChange(value, item)">
                  <el-option v-for="option in item.options" :key="option.value" :label="option.label"
                    :value="option.value" />
                </el-select>
              </el-form-item>
            </template>
            <template v-else-if="item.type === 'radio'">
              <slot v-if="item?.slotName" :name="item?.slotName" :formItem="item"></slot>
              <el-form-item v-else :prop="item.prop" :label="item.label"
                :label-position="item?.labelPosition || labelPosition" :label-width="item?.labelWidth || labelWidth"
                :rules="item.rules" v-bind="item.formItemAttrs">
                <el-radio-group v-model="formData[item.prop]">
                  <template v-for="option in item.options">
                    <el-radio :key="option.value" :value="option.value">
                      {{ option.label }}
                    </el-radio>
                  </template>
                </el-radio-group>
              </el-form-item>
            </template>
            <template v-else-if="item.type === 'checkbox'">
              <slot v-if="item.slotName" :name="item.slotName" :formItem="item"></slot>
              <el-form-item v-else :prop="item.prop" :label="item.label"
                :label-position="item?.labelPosition || labelPosition" :label-width="item?.labelWidth || labelWidth"
                :rules="item.rules" v-bind="item.formItemAttrs">
                <el-checkbox-group v-model="formData[item.prop]">
                  <template v-for="option in item.options">
                    <el-checkbox :key="option.value" :label="option.label" :value="option.value" />
                  </template>
                </el-checkbox-group>
              </el-form-item>
            </template>
            <!-- Upload start -->
            <template v-else-if="item.type === 'singleImageUpload'">
              <slot v-if="item.slotName" :name="item.slotName" :formItem="item"></slot>
              <el-form-item v-else :prop="item.prop" :label="item.label"
                :label-position="item?.labelPosition || labelPosition" :label-width="item?.labelWidth || labelWidth"
                :rules="item.rules" v-bind="item.formItemAttrs">

                <el-upload class="single-image-uploader" :action="uploadAction" :headers="headers"
                  :show-file-list="false" :before-upload="(response) => beforeSingleImageUploadUpload(response, item)
                    " :on-success="(response) => handleSingleImageUploadSuccess(response, item)
                      ">
                  <div v-if="formData[item.prop]" class="compact-upload">
                    <div class="compact-thumb" @click.stop>
                      <el-image v-if="!isPdfFile(formData[item.prop])" :src="formData[item.prop]"
                        :preview-src-list="[formData[item.prop]]" fit="cover" class="compact-thumb-img" lazy />
                      <span v-else class="compact-thumb-pdf"
                        @click.stop="previewSingleFile(formData[item.prop])">PDF</span>
                    </div>
                    <div class="compact-info">
                      <span class="compact-title">已上传</span>
                      <span class="compact-action">点击更换</span>
                    </div>
                  </div>
                  <div v-else class="compact-upload compact-upload--empty">
                    <i class="el-icon-plus compact-plus"></i>
                    <span class="compact-action">点击上传</span>
                  </div>
                </el-upload>

                <!-- <el-upload :action="uploadAction" :headers="headers" list-type="picture-card"
                  :before-upload="(file) => beforeSingleImageUpload(file, item)" :on-success="(response) => handleSingleImageUploadSuccess(response, item)
                    " :on-remove="(file, fileList) => handleRemove(file, fileList, item)
                      " :file-list="getFileList(item.prop)" :limit="1" :on-exceed="handleExceed">
                  <i slot="default" class="el-icon-plus"></i>
                  <div slot="file" slot-scope="{file}">
                    <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                    <span class="el-upload-list__item-actions">
                      <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                        <i class="el-icon-zoom-in"></i>
                      </span>
                      <span class="el-upload-list__item-delete" @click="handleRemove(file, null, item)">
                        <i class="el-icon-delete"></i>
                      </span>
                    </span>
                  </div>
                </el-upload> -->

              </el-form-item>
            </template>
            <!-- Upload end -->
            <template v-else-if="item.type === 'editor'">
              <slot v-if="item?.slotName" :name="item.slotName" :formItem="item"></slot>
              <el-form-item v-else :prop="item.prop" :label="item.label"
                :label-position="item?.labelPosition || labelPosition" :label-width="item?.labelWidth || labelWidth"
                :rules="item.rules" v-bind="item.formItemAttrs">
                <div style="border: 1px solid #ccc">
                  <!-- <Toolbar
                    style="border-bottom: 1px solid #ccc"
                    :editor="editor"
                    :defaultConfig="toolbarConfig"
                    :mode="mode"
                  /> -->
                  <Editor style="overflow-y: hidden" v-model="formData[item.prop]" :defaultConfig="editorConfig"
                    :mode="mode" @onCreated="onCreated" />
                </div>
              </el-form-item>
            </template>
            <!-- 子表格：按字典配置的列渲染，可增删行，行数受 minRow/maxRow 限制 -->
            <template v-else-if="item.type === 'subTable'">
              <slot v-if="item?.slotName" :name="item.slotName" :formItem="item"></slot>
              <el-form-item v-else :prop="item.prop" :label="item.label"
                :label-position="item?.labelPosition || labelPosition" :label-width="item?.labelWidth || labelWidth"
                :rules="item.rules" v-bind="item.formItemAttrs">
                <div class="sub-table">
                  <el-table :data="subRows(item)" border size="small" style="width: 100%">
                    <el-table-column type="index" label="序号" width="60" align="center" />
                    <el-table-column v-for="col in item.columns || []" :key="col.field" :label="col.label"
                      :width="col.width || ''">
                      <template slot-scope="{ row }">
                        <el-select v-if="col.type === 'select'" v-model="row[col.field]" size="small" clearable
                          style="width: 100%" :placeholder="'请选择' + col.label">
                          <el-option v-for="opt in col.options || []" :key="opt.value" :label="opt.label"
                            :value="opt.value" />
                        </el-select>
                        <el-date-picker v-else-if="col.type === 'date' || col.type === 'datetime'"
                          v-model="row[col.field]" :type="col.type" size="small" clearable
                          :value-format="col.type === 'date' ? 'yyyy-MM-dd' : 'yyyy-MM-dd HH:mm:ss'"
                          :placeholder="'请选择' + col.label" style="width: 100%" />
                        <el-input v-else-if="col.type === 'textarea'" v-model.trim="row[col.field]" type="textarea"
                          :rows="2" size="small" :placeholder="'请输入' + col.label" />
                        <el-input v-else v-model.trim="row[col.field]" size="small"
                          :placeholder="'请输入' + col.label" />
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" width="80" align="center">
                      <template slot-scope="{ $index }">
                        <el-button type="danger" link size="small" @click="removeSubRow(item, $index)">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="sub-table-footer">
                    <el-button size="small" type="primary" plain :disabled="isSubTableFull(item)"
                      @click="addSubRow(item)">添加一行</el-button>
                    <span class="sub-table-tip">{{ subTableTip(item) }}</span>
                  </div>
                </div>
              </el-form-item>
            </template>
          </el-col>
        </template>
        <slot name="handle"></slot>
      </el-row>
    </el-form>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>

    <el-dialog title="PDF 预览" :visible.sync="pdfPreviewVisible" width="80%" append-to-body @closed="closePdfPreview">
      <iframe v-if="pdfPreviewUrl" :src="pdfPreviewUrl"
        style="width: 100%; height: 70vh; border: none;"></iframe>
    </el-dialog>

  </div>
</template>

<script>
// @wangeditor/editor-for-vue
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import { signature } from "@/services/request/sign";
import { getAccessToken } from "@/utils/auth";
// types
import { InputType, DateRangeType } from "./types";

export default {
  components: { Editor, Toolbar },
  props: {
    formItems: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    rules: {
      type: Object,
      default: () => ({}),
    },
    labelPosition: {
      type: String,
      default: "",
    },
    labelWidth: {
      type: String,
      default: "",
    },
    formAttrs: {
      type: Object,
      default: () => ({}),
    },
    rowAttrs: {
      type: Object,
      default: () => ({ gutter: 30, type: "flex" }),
    },
    colAttrs: {
      type: Object,
      default: () => ({ span: 12 }),
    },
  },
  data() {
    return {
      formData: {},
      // @wangeditor/editor-for-vue
      editor: null,
      toolbarConfig: {},
      editorConfig: { placeholder: "请输入内容..." },
      mode: "default", // or 'simple'
      imageUrl: "",
      dialogVisible: false,
      dialogImageUrl: "",
      pdfPreviewVisible: false,
      pdfPreviewUrl: "",
      disabled: false,
      // 缓存文件列表，避免闪烁
      fileLists: {}
    };
  },
  computed: {
    headers() {
      const signObj = signature();
      const config = {
        ...signObj,
        nonce: signObj.timestamp,
        ["tenant-id"]: 88,
      };
      // 设置 token：未登录时不带 Authorization（不再用 "Bearer test1" 兜底，避免误命中服务端模拟登录）
      if (getAccessToken()) {
        config["Authorization"] = "Bearer " + getAccessToken();
      }
      return config;
    },
    uploadAction() {
      return process.env.VUE_APP_UPLOAD_API;
    },
    isInputType() {
      return (type) => InputType.includes(type);
    },
    isDateRangeType() {
      return (type) => DateRangeType.includes(type);
    },
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal !== this.formData) {
          this.formData = newVal;
        }
      },
      deep: true,
      immediate: true,
    },
    formData: {
      handler(newVal) {
        this.$emit("update:value", newVal);
      },
      deep: true,
    },
  },
  methods: {
    // ==================== 子表格 ====================
    subRows(item) {
      return Array.isArray(this.formData[item.prop]) ? this.formData[item.prop] : [];
    },
    minRowOf(item) {
      return Number(item?.minRow) || 0;
    },
    maxRowOf(item) {
      return Number(item?.maxRow) || 0;
    },
    isSubTableFull(item) {
      const max = this.maxRowOf(item);
      return max > 0 && this.subRows(item).length >= max;
    },
    subTableTip(item) {
      const min = this.minRowOf(item);
      const max = this.maxRowOf(item);
      if (min > 0 && max > 0) return `需填写 ${min} ~ ${max} 行`;
      if (min > 0) return `至少填写 ${min} 行`;
      if (max > 0) return `最多填写 ${max} 行`;
      return "";
    },
    addSubRow(item) {
      if (!Array.isArray(this.formData[item.prop])) {
        this.$set(this.formData, item.prop, []);
      }
      if (this.isSubTableFull(item)) {
        this.$message.warning(`最多只能填写 ${this.maxRowOf(item)} 行`);
        return;
      }
      const row = {};
      (item.columns || []).forEach((col) => {
        row[col.field] = "";
      });
      this.formData[item.prop].push(row);
    },
    removeSubRow(item, index) {
      const rows = this.subRows(item);
      const min = this.minRowOf(item);
      if (min > 0 && rows.length <= min) {
        this.$message.warning(`至少需要保留 ${min} 行`);
        return;
      }
      rows.splice(index, 1);
    },
    handleRemove(file, fileList, item) {
      // 清空表单数据中对应的图片字段
      this.formData[item.prop] = '';
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload(file) {
      console.log(file);
    },

    // 获取文件列表用于回显（优化闪烁）
    getFileList(prop) {
      const url = this.formData[prop];

      // 如果没有图片，返回空数组
      if (!url) {
        // 清空缓存
        if (this.fileLists[prop]) {
          this.fileLists[prop] = [];
        }
        return [];
      }

      // 如果缓存存在且URL相同，直接返回缓存
      if (this.fileLists[prop] && this.fileLists[prop].length > 0 &&
        this.fileLists[prop][0].url === url) {
        return this.fileLists[prop];
      }

      // 创建新的文件列表并缓存
      this.fileLists[prop] = [{
        name: '图片',
        url: url
      }];
      return this.fileLists[prop];
    },

    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
    },

    isPdfFile(url) {
      if (!url) return false;
      return url.toLowerCase().split("?")[0].endsWith(".pdf");
    },
    // PDF 预览：文件地址可能带 attachment 响应头，iframe 直接指向会被浏览器当成下载，
    // 这里先取成 blob 再交给浏览器内置阅读器渲染，关闭时释放 blob 地址
    async previewSingleFile(url) {
      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }
        const buffer = await response.arrayBuffer();
        if (!this.isPdfBuffer(buffer)) {
          this.$message.error("文件内容不是有效的 PDF，请检查该文件地址是否可以直接访问");
          return;
        }
        this.pdfPreviewUrl = URL.createObjectURL(new Blob([buffer], { type: "application/pdf" }));
        this.pdfPreviewVisible = true;
      } catch (e) {
        this.$message.error("PDF 预览失败，请确认文件地址允许跨域访问");
      }
    },
    // PDF 文件头为 %PDF
    isPdfBuffer(buffer) {
      if (!buffer || buffer.byteLength < 4) return false;
      const head = new Uint8Array(buffer.slice(0, 4));
      return head[0] === 0x25 && head[1] === 0x50 && head[2] === 0x44 && head[3] === 0x46;
    },
    closePdfPreview() {
      if (this.pdfPreviewUrl) {
        URL.revokeObjectURL(this.pdfPreviewUrl);
        this.pdfPreviewUrl = "";
      }
    },
    beforeSingleImageUploadUpload(file, item) {
      const isImage = ["image/jpeg", "image/png", "image/webp"].includes(file.type);
      const isPdf = file.type === "application/pdf";
      if (!isImage && !isPdf) {
        this.$message.error("只能上传 JPG/PNG/WEBP 图片或 PDF 文件!");
        return false; // 阻止上传
      }
      // 图片 30KB ~ 500KB，PDF 只限上限 1MB（不设下限）
      const minSize = 30 * 1024;
      const maxSize = isPdf ? 1024 * 1024 : 500 * 1024;
      if (!isPdf && file.size < minSize) {
        this.$message.error("上传图片大小不能小于 30KB!");
        return false; // 阻止上传
      }
      if (file.size > maxSize) {
        this.$message.error(isPdf ? "上传 PDF 大小不能超过 1MB!" : "上传图片大小不能超过 500KB!");
        return false; // 阻止上传
      }
      return true;
    },
    // 单图上传前检查
    beforeSingleImageUpload(file, item) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/webp" || file.type === "image/png";
      const isLt500KB = file.size < 500 * 1024;

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG/PNG 或 webp 格式!");
        return false; // 阻止上传
      }
      if (!isLt500KB) {
        this.$message.error("上传图片大小不能超过 500KB!");
        return false; // 阻止上传
      }
      // 如果已有图片，提示用户先删除
      if (this.formData[item.prop]) {
        this.$message.warning('请先删除已上传的图片再重新上传');
        return false; // 阻止上传
      }
      return true;
    },
    // 超过限制时的提示
    handleExceed(files, fileList) {
      this.$message.warning('只能上传一张图片，请先删除已上传的图片');
    },
    handleSingleImageUploadSuccess(response, item) {
      console.log("handleAvatarSuccess: ", response, item);
      this.formData[item.prop] = response?.data;
    },
    /**
     * @description 监听 select 选中值发生变化 查找选中值对应的label
     * */
    handleSelectChange(value, item) {
      try {
        const { options } = item;
        const findOption = options.find((item) => item.value === value);
        this.formData[`${item.prop}Label`] = findOption.label;
      } catch (error) {
        console.error("Error handleSelectChange", error);
      }
    },
  },
  beforeDestroy() {
    const editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
  },
};
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>
<style scoped lang="scss">
.sub-table {
  width: 100%;

  .sub-table-footer {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 8px;
  }

  .sub-table-tip {
    font-size: 12px;
    color: #909399;
  }
}

.single-image-uploader {
  :deep(.el-upload) {
    width: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  :deep(.el-upload:hover) {
    border-color: #409eff;
  }
}

// 紧凑行：64px 缩略图 + 文字说明，单项约 80px 高，材料多时不会把页面拉长
.compact-upload {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  min-height: 64px;
}

.compact-upload--empty {
  justify-content: center;
  color: #8c939d;
}

.compact-plus {
  font-size: 20px;
  color: #8c939d;
}

.compact-thumb {
  width: 64px;
  height: 64px;
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
  border-radius: 4px;
  overflow: hidden;
  cursor: zoom-in;
}

.compact-thumb-img {
  display: block;
  width: 100%;
  height: 100%;

  :deep(.el-image__inner) {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.compact-thumb-pdf {
  font-size: 13px;
  font-weight: 600;
  color: #f56c6c;
}

.compact-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  line-height: 1.2;
}

.compact-title {
  color: #303133;
}

.compact-action {
  color: #409eff;
}
</style>
